import { Alert, Box, CircularProgress, Snackbar } from "@mui/material";
import PaperCustomized from "../../../common/components/PaperCustomized";
import { useDispatch, useSelector } from "react-redux";
import ListHistorique from "./ListHistorique";
import { useEffect, useState } from "react";
import ButtonCustomized from "../../../common/components/ButtonCustomized";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useNavigate, useParams } from "react-router-dom";
import ScrollToTop from "../../../common/components/ScrollToTop";
import StickyCustomized from "../../../common/components/StickyCustomized";
import { Helmet } from "react-helmet";
import {
  clearTiErrors,
  clearTiHistorique,
  fetchTiHistorique,
} from "../state/TiActions";
import { GO_BACK } from "../../../common/constants/routerConstants";

function TiHistorique(props) {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const tiReducer = useSelector((state) => state.tiReducer);
  const error = tiReducer?.error;
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const isLoading = tiReducer?.isHistoriqueLoading;

  useEffect(() => {
    dispatch(fetchTiHistorique(id));
  }, []);

  useEffect(() => {
    if (error !== null) {
      setAlertMessage(error);
      setAlertOpen(true);
      setSeverity("error");
    }
  }, [error]);

  const handleSnackClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    dispatch(clearTiErrors());
    navigate(GO_BACK);
    setAlertOpen(false);
  };

  const [pagination, setPagination] = useState({
    page: 0,
    pageSize: 10,
  });

  const handleGoBack = () => {
    navigate(GO_BACK);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        gap: "20px",
      }}
    >
      <Helmet>
        <title>{"Historique - Portail Banques"}</title>
      </Helmet>
      <StickyCustomized>
        <PaperCustomized forActions={true}>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <ButtonCustomized
              onClick={handleGoBack}
              title="Retour"
              startIcon={<ArrowBackIosIcon />}
            />
          </Box>
        </PaperCustomized>
      </StickyCustomized>

      {true === false ? (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexGrow: 1,
            mt: "20%",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            gap: "20px",
          }}
        >
          <ListHistorique
            historique={tiReducer?.historique}
            paginationModel={pagination}
            setPaginationModel={setPagination}
            loading={isLoading}
          />
        </Box>
      )}
      <Box>
        <Snackbar
          open={alertOpen}
          autoHideDuration={5000}
          onClose={handleSnackClose}
        >
          <Alert
            onClose={handleSnackClose}
            severity={severity}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {alertMessage}
          </Alert>
        </Snackbar>
      </Box>
      <ScrollToTop />
    </Box>
  );
}

export default TiHistorique;
